/* Renders the three states a fetch can land in.
 *
 * The point is that "the request failed" and "there is nothing here yet" must
 * not look identical. Catching an error and setting an empty array tells the
 * user they have no films when the truth is the server is down. */
export function AsyncSection({ status, error, isEmpty, emptyMessage, onRetry, children }) {
  if (status === "loading") {
    return (
      <p className="async-state" role="status">
        Loading…
      </p>
    );
  }

  if (status === "error") {
    return (
      <div className="async-state async-state--error" role="alert">
        <p>{error || "Something went wrong."}</p>
        {onRetry && (
          <button type="button" className="async-state__retry" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    );
  }

  if (isEmpty) {
    return <p className="async-state async-state--empty">{emptyMessage}</p>;
  }

  return children;
}
